import EmailPreferencesPage from './EmailPreferencesPage'

export default EmailPreferencesPage
// eslint-disable-next-line import/export
export * from './EmailPreferencesPage'
